export const iconFontAwesomeHolidaysHollyBerry = (
	<i className="fa-solid fa-holly-berry"></i>
);
